import { Flex, Text } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { LanguageSwitcher } from '#features/i18n/components/LanguageSwitcher';
import { Link } from '#features/ui';
import { FOOTER_ROUTES } from '../../constants/footerLinks';

/**
 * What a signed-in user gets instead of the full footer.
 *
 * The big footer exists for guests and for search engines: it carries the internal
 * links that keep /discord-lfg-bot, the blog and the marketing pages ranking. A signed-in
 * person is served by the app itself, and vacancies / "partner with us" / a Google Play
 * button are noise on a page they are actually using — but Terms, Privacy and the
 * language switch still have to be reachable from anywhere, hence this strip.
 *
 * Crawlers are never signed in, so swapping the footer here cannot affect indexing.
 */
export const SlimFooter = () => {
  const { t } = useLingui();

  return (
    <Flex
      as="footer"
      mt={8}
      pt={4}
      pb={6}
      borderTop="1px solid"
      borderColor="whiteAlpha.50"
      alignItems="center"
      justifyContent="space-between"
      gap={4}
      flexWrap="wrap"
      textStyle="caption"
      color="fg.muted"
    >
      <Text>© {new Date().getFullYear()} Teamplay.gg</Text>

      <Flex alignItems="center" gap={4} flexWrap="wrap">
        <Link
          to={FOOTER_ROUTES.terms}
          textStyle="caption"
          color="fg.muted"
          _hover={{ color: 'fg' }}
        >
          {t`footer.terms`}
        </Link>
        <Link
          to={FOOTER_ROUTES.privacy}
          textStyle="caption"
          color="fg.muted"
          _hover={{ color: 'fg' }}
        >
          {t`footer.privacyPolicy`}
        </Link>

        <LanguageSwitcher compact={false} />
      </Flex>
    </Flex>
  );
};
